export function getUrl() {
    if (typeof window !== 'undefined') {
        const { protocol, hostname, pathname } = window.location;
        return `${protocol}//${hostname}${pathname}`;
    }
    return '';
}
export function getUrlPath() {
    return window.location?.pathname || '';
}
export function urlsAreEqual(url1, url2) {
    if (typeof window !== 'undefined') {
        const { protocol, hostname } = window.location;
        const base = `${protocol}//${hostname}`;
        try {
            const urlObj1 = new URL(url1, base);
            const urlObj2 = new URL(url2, base);
            const absUrl1 = `${urlObj1.protocol}//${urlObj1.hostname}${urlObj1.pathname}`;
            const absUrl2 = `${urlObj2.protocol}//${urlObj2.hostname}${urlObj2.pathname}`;
            return absUrl1 === absUrl2;
        }
        catch (e) {
            console.error('Error comparing URLs:', e);
            return false;
        }
    }
    return false;
}
export function getEnvironmentFromHostname(hostname) {
    if (typeof hostname !== 'string') {
        return 'production';
    }
    if (hostname.includes('localhost')) {
        return 'development';
    }
    if (hostname.includes('squareupstaging')) {
        return 'staging';
    }
    return 'production';
}
